import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function load() {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getTypeDefaut
  }).then(r => r.data);
}

export default {
  load
};



// WEBPACK FOOTER //
// ./src/repositories/type-defaut.repository.js